import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ButtonClickedEvent, makeAnalyticsData, withAnalytics } from '@atlassian/mpac-analytics';
import React, { PureComponent } from 'react';
import { ANALYTICS_CATEGORY_NAVIGATION, ANALYTICS_SUBJECT_ID_CREATE_TOKEN } from '../../../../../analytics/Events';
import ConfirmCancelFooter from '../../common/ConfirmCancelFooter';
import { jsx as _jsx } from "react/jsx-runtime";
const PRIMARY_CTA_LABEL = 'Create';
export class DialogCreateAppSpecificPasswordFooterBase extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "generateAppSpecificPassword", name => () => {
      this.props.fireAnalyticsEvent(makeAnalyticsData({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_CREATE_TOKEN,
        attributes: {
          label: PRIMARY_CTA_LABEL
        },
        category: ANALYTICS_CATEGORY_NAVIGATION
      }).toObject());
      this.props.generateAppSpecificPassword({
        name,
        context: this.props.context,
        hostConfig: this.props.hostConfig
      });
    });
    _defineProperty(this, "render", () => this.props.name ? /*#__PURE__*/_jsx(ConfirmCancelFooter, {
      closeInstallDialog: this.props.closeInstallDialog,
      isLoading: false,
      isPrimaryDisabled: false,
      onPrimaryCTAClick: this.generateAppSpecificPassword(this.props.name),
      primaryCTALabel: PRIMARY_CTA_LABEL
    }) : /*#__PURE__*/_jsx(ConfirmCancelFooter, {
      closeInstallDialog: this.props.closeInstallDialog,
      isLoading: false,
      isPrimaryDisabled: true,
      primaryCTALabel: PRIMARY_CTA_LABEL
    }));
  }
}
export default withAnalytics(DialogCreateAppSpecificPasswordFooterBase);